import { convertTo12HourFormat } from './convertTo12HourFormat';

export const getFormattedTimeWindow = (
  windowStartTime: string,
  windowEndTime: string,
) =>
  `${convertTo12HourFormat(windowStartTime)} - ${convertTo12HourFormat(
    windowEndTime,
  )}`;
